module.exports = __webpack_public_path__ + "img/32_18.55f132e1.png";